module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-5-32add07cc05719bf9b3d438697f92253.png";